import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import axios from "../../../api/axios";
import { EventTabs } from "../../../utils/constants";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";

const OptionalCostsForm = () => {
  const { enqueueSnackbar } = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const eventid = params.eventid;

  const [eventData, setEventData] = useState(null);

  useEffect(() => {
    if (!eventid) return;
    let cancelled = false;
    const run = async () => {
      try {
        const resp = await axios.get(`/api/events/${eventid}`);
        if (!cancelled) setEventData(resp.data);
      } catch (e) {
        // Non-critical — header shows fallback text
      }
    };
    run();
    return () => { cancelled = true; };
  }, [eventid]);

  const urlSegment = location.pathname.split('/')[3]?.toLowerCase() || 'optionalcosts';
  const activeTabName = (EventTabs.find(t => t.path === urlSegment) || EventTabs[2]).name;
  const headerTitle = eventData?.BP_Title
    ? `Edit Optional Costs: ${eventData.BP_Title}`
    : 'Edit Optional Costs';

  return (
    <main>
      {/* Blue Header Banner */}
      <div className="full-row light-blue">
        <div className="container-fluid">
          <div className="row text-white pt-3 pb-3">
            <div className="col-md-12 text-white">
              <h1 className="text-uppercase">{headerTitle}</h1>
              <p>Manage optional costs</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="full-row white">
        {/* Sticky Tab Bar */}
        <Box
          sx={{
            position: 'sticky',
            top: 40,
            zIndex: 100,
            backgroundColor: 'white',
            borderBottom: 1,
            borderColor: 'divider',
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
          }}
        >
          <Box sx={{ px: 3 }}>
            <Tabs
              value={activeTabName}
              onChange={(_, newValue) => {
                const tab = EventTabs.find(t => t.name === newValue);
                if (tab) navigate(`/admin/events/${tab.path}/${eventid}`);
              }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              TabIndicatorProps={{ sx: { height: 3, borderRadius: 2, backgroundColor: '#0074c8' } }}
              sx={{
                minHeight: 44,
                '& .MuiTabs-flexContainer': { gap: 1 },
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontFamily: 'proxima-nova, sans-serif',
                  fontWeight: 600,
                  fontSize: { xs: 14, sm: 16 },
                  minHeight: 44,
                  px: 2,
                  borderRadius: 1,
                  whiteSpace: 'nowrap',
                  color: 'text.primary',
                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.06)' },
                  '&.Mui-selected': { color: '#0074c8' },
                },
              }}
            >
              {EventTabs.map((t) => (
                <Tab key={t.id} value={t.name} label={t.label || t.name} wrapped={false} />
              ))}
            </Tabs>
          </Box>
        </Box>

        <Box sx={{ p: 3 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ textTransform: 'none', mb: 1 }}>Optional Costs</Typography>
            <Typography sx={{ color: 'text.secondary' }}>Optional costs configuration coming soon.</Typography>
          </Paper>
        </Box>
      </div>
    </main>
  );
};

export default OptionalCostsForm;
